import { ITenantConfig } from '../interfaces/tenant-config.interface';

export class TenantConfig {
    id: string;
    key: string;
    value: any;

    constructor(query: ITenantConfig) {
        this.id = query.id.toString();
        this.key = query.config_key;
        this.value = query.config_value;
    }
}
